import styled from "styled-components";
import { AnimationCommonCardListWrapper, beforeCss } from "../../atom";

export const AnimationGiftCouponWrapper = styled.div`
  .card-list-wrapper {
    overflow-x: hidden;
  }
`;
export const CardListContent = styled.div`
  position: relative;
  .scroll-button {
    position: absolute;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin: auto 0;
    z-index: 10;
  }

  .left-button {
    left: -30px;
  }

  .right-button {
    right: -30px;
  }
`;
export const AnimationGiftCouponCardList = styled(
  AnimationCommonCardListWrapper
)`
  width: max-content;
  padding-right: 10px;
`;

export const AnimationGiftCouponCard = styled.div<{
  isActive: boolean;
  heightCard: boolean;
}>`
  position: relative;
  width: 224px;
  height: ${(p) => (p.heightCard ? "167px" : "134px")};
  background: ${(p) => (p.isActive ? "rgba(19, 203, 117, 0.04)" : "#292B2F")};
  border-radius: 8px;
  padding: 20px 11px 18px 14px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 0 0 1px rgba(73, 83, 89, 1);
  cursor: pointer;
  gap: 4px;
  ${(p) => p.isActive && beforeCss}
  .recharge-price {
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 500;
    font-size: 16px;
    height: 42px;
    width: 100%;
    .price {
      font-size: 30px;
    }
  }
  .extra-welfare {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .tip-text {
      color: #ffffff;
      height: 20px;
      width: 100%;
      margin-bottom: 6px;
      font-size: 12px;
    }
    .gift-amount {
      padding: 0 8px;
      font-size: 14px;
      line-height: 26px;
      color: #ffffff;
      background: ${(p) =>
        p.isActive ? "rgba(19, 203, 117, 0.15)" : "rgba(255, 255, 255, 0.06)"};
      border-radius: 20px;
      display: flex;
      align-items: center;
      width: 100%;
      svg {
        margin-right: 6px;
        fill: ${(p) => (p.isActive ? "var(--main-color)" : "#727E84")};
      }
    }
  }
  .luck-draw-text {
    margin-top: 8px;
    width: 100%;
    height: 26px;
    border-radius: 20px;
    background-color: ${(p) => (p.isActive ? "#FFBD1526" : "#3D4045")};
    font-size: 14px;
    font-weight: 500;
    line-height: 26px;
    display: flex;
    align-items: center;
    padding: 0 8px;
    gap: 6px;
  }
  :hover {
    background: rgba(19, 203, 117, 0.04);
    ${beforeCss};
    .gift-amount {
      background: rgba(19, 203, 117, 0.15);
      svg {
        fill: var(--main-color);
      }
    }
    .luck-draw-text {
      background-color: #ffbd1526;
    }
  }
`;
